<script>
  import { _ } from "svelte-i18n"

  let startYear = 2020
  let curYear = new Date().getFullYear()
  let copyrightRange
  if (startYear === curYear) copyrightRange = curYear
  else copyrightRange = `${startYear} - ${curYear}`
</script>

<div>
  &copy
  {copyrightRange}
  <a href="https://fractalbit.dev/">{$_("copyright")}</a>
</div>

<style>
  div {
    position: absolute;
    bottom: 20px;
    margin: 0 auto;

    font-size: 1rem;
    color: white;
    background: rgba(0, 0, 0, 0.6);
    padding: 20px 50px;
    border-radius: 20px;
  }

  a {
    color: white;
  }

  @media (max-width: 400px) {
    div {
      font-size: 0.8rem;
    }
  }
</style>
